export default __webpack_public_path__ + "static/media/train1.5e396860.jpg";